import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoesControleCategoria.vue?vue&type=template&id=2a6e8fbb"
import script from "./PlanejamentoContratoFormAcoesControleCategoria.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAcoesControleCategoria.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoFormAcoesControleCategoria.vue?vue&type=style&index=0&id=2a6e8fbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports